import { AppName, Encounter, EncounterStatus } from '@hb/shared'

export type EncounterHoldAction = 'place' | 'release'

// §1.6.2 Hold from Billing footer link state. The link is provider-facing only (never
// the admin app — billing team gets no hold/release control anywhere) and only appears
// on authenticated notes; it offers 'release' while a hold is active. Applies to all
// encounter types (decision 7) — no type gating.
export const getEncounterHoldAction = (
  encounter: Pick<Encounter, 'status' | 'currentBillingHold'>,
  appName: AppName,
): EncounterHoldAction | null => {
  if (appName === 'app') return null
  if (encounter.status !== EncounterStatus.AUTHENTICATED) return null
  return encounter.currentBillingHold ? 'release' : 'place'
}
